module.exports = __webpack_public_path__ + "static/media/pm-quirky.c689ffa0.png";